export const allowedNonACEClubs = ['188', '240', '001'];
export const guidewireClubs = ['240'];
export const aceClubs = ['004', '018', '601', '252', '258', '036', '215', '065'];
export const basePath = '/insurance/make-a-payment/';
export const autoPayPath = '/insurance/autopay-enrollment/';
export const maintenanceStartDate = '2023-03-10T23:00:00Z';
export const maintenanceEndDate = '2023-03-13T13:00:00Z';
